import { useMutation } from "react-query";

import { onboardingFlagsApi } from "@/react/api/onboardingFlagsApi";

import { usePunditUserContext } from "../contexts/punditUserContext";

interface UseOnboardingFlagsProps {
  onEnableFlagSuccess?: () => void;
}

export const useOnboardingFlags = ({
  onEnableFlagSuccess,
}: UseOnboardingFlagsProps) => {
  const {
    onboardingFlags,
    refetch: refetchPunditUserContext,
    isLoading,
  } = usePunditUserContext();

  const enableFlagMutation = useMutation({
    mutationFn: onboardingFlagsApi.enable,
    onSuccess: () => {
      onEnableFlagSuccess?.();
      void refetchPunditUserContext();
    },
  });

  return {
    onboardingFlags,
    enableFlag: enableFlagMutation.mutate,
    isUpdating: enableFlagMutation.isPending,
    areFlagsLoading: isLoading,
  };
};
